/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Model_Text_To_SpeechInputs */



/**
* | output |
* | --- |
* | "Text to speech (GPT-4o mini TTS)" |
*
* @param {Usage_Model_Text_To_SpeechInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_model_text_to_speech = /** @type {((inputs?: Usage_Model_Text_To_SpeechInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Model_Text_To_SpeechInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Text zu Sprache (GPT-4o mini TTS)")
	return /** @type {LocalizedString} */ ("Text to speech (GPT-4o mini TTS)")
});